import { render, staticRenderFns } from "./PageFooter.component.vue?vue&type=template&id=3ee1c4bf&scoped=true"
import script from "./PageFooter.component.vue?vue&type=script&lang=ts"
export * from "./PageFooter.component.vue?vue&type=script&lang=ts"
import style0 from "./PageFooter.component.vue?vue&type=style&index=0&id=3ee1c4bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee1c4bf",
  null
  
)

export default component.exports